import { Alert, Input, Radio, message } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../../redux/auth/actions";
import { selectLoading } from "../../redux/auth/selectors";
import { store } from "../../redux/store";
import User from "../../service/User";

const Onboarding = () => {
  const loading = useSelector(selectLoading);
  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const [name, setName] = useState("");
  const [isBusiness, setIsBusiness] = useState(true);
  const [employeeStrength, setEmployeeStrength] = useState(1);
  const [address, setAddress] = useState({
    street: "",
    nr: "",
    postcode: "",
    city: "",
  });
  const [contactNumber, setContactNumber] = useState("");

  const handleSubmit = async () => {
    await User.updateProfile({
      name,
      isBusiness,
      employeeStrength,
      address,
      contactNumber,
    });

    const me = await User.me();
    if (!me?.data) return message.error("Error");

    store.dispatch(login(me.data));

    window.location.href = "/app";
  };

  const handleNext = () => {
    if (step === 5) return handleSubmit();
    setStep((s) => s + 1);
  };

  return (
    <>
      <div data-ms-form="signup" className="form-block w-form">
        <h2 className="mb-30">Onboarding</h2>

        {step === 0 && (
          <Alert
            type="info"
            message="Welcome to SynrgyRisk! To tailor the platform to your needs, you will need to provide a few details about you and your business. Please click next to continue."
          />
        )}

        {step === 1 && (
          <div className="form-field">
            <div className="flex justify-center">
              <label className="label">
                Are you a business or an individual?
              </label>
            </div>
            <div className="flex justify-center">
              <Radio.Group
                defaultValue="b"
                buttonStyle="solid"
                onChange={(e) => {
                  setIsBusiness(e.target.value === "b");
                }}
              >
                <Radio.Button value="b">Business</Radio.Button>
                <Radio.Button value="i">Individual</Radio.Button>
              </Radio.Group>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="form-field">
            <label className="label">
              {isBusiness ? "Company name" : "Full name"}
            </label>
            <input
              type="text"
              className="field nonsvg w-input"
              maxLength={256}
              name="text"
              data-name="text"
              placeholder={`Enter ${isBusiness ? "company name" : "full name"}`}
              id="text"
              data-ms-member="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        )}

        {step === 3 && (
          <div className="form-field">
            <label className="label">{"Company Headcount"}</label>
            <input
              type="number"
              className="field nonsvg w-input"
              maxLength={256}
              placeholder={`Enter company headcount`}
              value={employeeStrength}
              onChange={(e) => {
                setEmployeeStrength(parseInt(e.target.value));
              }}
            />
          </div>
        )}

        {step === 4 && (
          <div className="form-field">
            <div className="flex w-full">
              <div className="w-full">
                <label>Street</label>
                <Input
                  value={address.street}
                  onChange={(e) =>
                    setAddress((a) => ({ ...a, street: e.target.value }))
                  }
                />
              </div>
              <div className="w-1/4">
                <label>No.</label>
                <Input
                  value={address.nr}
                  onChange={(e) =>
                    setAddress((a) => ({ ...a, nr: e.target.value }))
                  }
                />
              </div>
            </div>
            <div className="flex w-full">
              <div className="w-1/3">
                <label>Post Code</label>
                <Input
                  value={address.postcode}
                  onChange={(e) =>
                    setAddress((a) => ({ ...a, postcode: e.target.value }))
                  }
                />
              </div>
              <div className="w-full">
                <label>City</label>
                <Input
                  value={address.city}
                  onChange={(e) =>
                    setAddress((a) => ({ ...a, city: e.target.value }))
                  }
                />
              </div>
            </div>
          </div>
        )}

        {step === 5 && (
          <div className="form-field">
            <label className="label">Contact Number</label>
            <input
              type="text"
              className="field nonsvg w-input"
              maxLength={256}
              name="text"
              data-name="text"
              placeholder={`Enter phone number`}
              id="text"
              data-ms-member="text"
              value={contactNumber}
              onChange={(e) => setContactNumber(e.target.value)}
            />
          </div>
        )}

        <button
          onClick={handleNext}
          class="text-white [&>*]:hover:stroke-[#294895] [&>*]:hover:text-[#294895] button w-button focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center mr-2 inline-flex items-center"
        >
          {loading && (
            <svg
              aria-hidden="true"
              role="status"
              class="inline mr-3 w-4 h-4 text-white animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              ></path>
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              ></path>
            </svg>
          )}
          {step === 5 ? "Finish" : "Next"}
        </button>
      </div>
    </>
  );
};

export default Onboarding;
